import santa from '../../icons/santa.png';
import './Santa.css';

export default function SantaComingSoon() {
  return (
    <div className="santa-screen">
      <div className="santa-card">
        <img src={santa} alt="Santa" className="santa-icon" />
        <p className="santa-message">
          Coming Soon! Santa is busy preparing for Christmas. Check back later to see how busy he
          has been.
        </p>
      </div>
    </div>
  );
}
